export const SET = 'Analysis/data/blocks/SET';

export function setBlocks(blocks) {
  return {
    type: SET,
    blocks
  }
}